import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { KioskState } from ".";
import { login } from "../actions/configActions";
import { logout } from "../actions/userActions";
import Init from "./callStates/Init";
import WrongUnamePwd from "./callStates/WrongUsernamePassword";
import TokenInvalid from "./callStates/TokenInvalid";
import TokenExpired from "./callStates/TokenExpired";
import Calling from "./callStates/Call";
import InCall from "./callStates/InCall";
import InMainCall from "./callStates/InMainCall";
import CallCompleted from "./callStates/CallCompleted";
import RejectedRemote from "./callStates/RejectedRemote";
import TerminatedRemote from "./callStates/TerminatedRemote";
import UnknownNumber from "./callStates/UnknownNumber";
import FourOFour from "../containers/FourOFour";
import ConnectionStatus from "./ConnectionStatus";
import parseQueryParams from "../modules/parse-query-params";
import { inIframe } from "../misc/inIframe";

class KioskPage extends React.Component {
  init = () => {
    if (!this.props.anonymous) {
      const token = this.props.router.location.search.substr(1);
      const tokenValue = parseQueryParams(token);
      this.props.login(tokenValue.username, tokenValue.password, token);
      return;
    }
  };

  render() {
    if (
      !this.props.kiosk ||
      (!this.props.inIframe && inIframe()) ||
      (this.props.forceIframe && !inIframe())
    ) {
      return <FourOFour />;
    }

    const { kioskState } = this.props;

    switch (kioskState) {
      case KioskState.init:
        this.init();
        return <Init />;
      case KioskState.ready:
        return <CallCompleted />;
      case KioskState.wrongUsernamePassword:
        return <WrongUnamePwd />;
      case KioskState.tokenInvalid:
        return <TokenInvalid />;
      case KioskState.tokenExpired:
        return <TokenExpired />;
      case KioskState.acceptedRemote:
        if (this.props.kiosk_main_layout) {
          return <InMainCall />;
        } else {
          return <InCall />;
        }
      case KioskState.calling:
        return <Calling />;
      case KioskState.rejectedRemote:
        return <RejectedRemote />;
      case KioskState.terminatedRemote:
        return <TerminatedRemote />;
      case KioskState.unregisteredNumber:
      case KioskState.unknownNumber:
        this.props.logout();
        return <UnknownNumber />;
      case KioskState.terminatedLocal:
      case KioskState.callCompleted:
        this.props.logout();
        return <CallCompleted />;
      default:
        break;
    }
    return <ConnectionStatus status={kioskState} />;
  }
}

KioskPage.propTypes = {
  kioskState: PropTypes.number.isRequired,
  to: PropTypes.string,
};

const dispatchToProps = dispatch => {
  return {
    login: (username, password, token) => {
      return dispatch(login(username, password, token));
    },
    logout: () => {
      return dispatch(logout());
    },
  };
};

const stateToProps = (state, router) => {
  return {
    anonymous: state.config.mode.anonymous_enabled,
    kiosk: state.config.mode.kiosk,
    kioskState: state.kiosk.state,
    kiosk_main_layout: state.config.mode.kiosk_main_layout,
    router: router,
    inIframe: state.config.mode.inIframe,
    forceIframe: state.config.mode.forceIframe,
  };
};

export default connect(stateToProps, dispatchToProps)(KioskPage);






// WEBPACK FOOTER //
// ./src/kiosk/KioskPage.jsx